module.exports = __webpack_public_path__ + "assets/img/kyyzk2.0a67cea0.png";